// import jwtDecode from 'jwt-decode';
import { verify, sign } from 'jsonwebtoken';
//
import axios from './axios';

// ----------------------------------------------------------------------

const isValidToken = (accessToken) => {
  if (!accessToken) {
    return false;
  }
  return true;
  // const decoded = jwtDecode(accessToken);
  // const currentTime = Date.now() / 1000;
  // return decoded.exp > currentTime;
};

//  const handleTokenExpired = (exp) => {
//   let expiredTimer;

//   window.clearTimeout(expiredTimer);
//   const currentTime = Date.now();
//   const timeLeft = exp * 1000 - currentTime;
//   expiredTimer = window.setTimeout(() => {
//     // You can do what ever you want here, like show a notification
//   }, timeLeft);
// };

const checkSession = async() => {
  if (localStorage.getItem('mobileAccessToken')) {
    return true
  } else {
    return false
  }
}

const setSession = (accessToken) => {
  if (accessToken) {
    localStorage.setItem('mobileAccessToken', accessToken);
    axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
    // This function below will handle when token is expired
    // const { exp } = jwtDecode(accessToken);
    // handleTokenExpired(exp);
  } else {
    localStorage.removeItem('mobileAccessToken');
    delete axios.defaults.headers.common.Authorization;
  }
};


export { isValidToken, checkSession, setSession, verify, sign };
